// <s-pdp-gallery>: square scroll-snap product gallery. Thumbnail and dot buttons send the
// "--go" command with data-index; the active marker follows swipes and thumbnail clicks.
class SPdpGallery extends HTMLElement {
  #controller;
  #frame = 0;
  #track;

  connectedCallback() {
    this.#track = this.querySelector('[data-gallery-track]');
    if (!this.#track) return;
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    this.addEventListener('command', this.#onCommand, { signal });
    this.#track.addEventListener('scroll', this.#onScroll, { passive: true, signal });
    this.#update();
  }

  disconnectedCallback() {
    this.#controller?.abort();
    cancelAnimationFrame(this.#frame);
  }

  #onCommand = (event) => {
    if (event.command !== '--go') return;
    const index = Number.parseInt(event.source?.dataset.index ?? '', 10);
    const slide = this.#track.children[index];
    if (!slide) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.#track.scrollTo({ left: slide.offsetLeft - this.#track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    this.#setActive(index);
  };

  #onScroll = () => {
    cancelAnimationFrame(this.#frame);
    this.#frame = requestAnimationFrame(() => this.#update());
  };

  #update() {
    const width = this.#track.clientWidth || 1;
    const index = Math.round(Math.abs(this.#track.scrollLeft) / width);
    this.#setActive(index);
  }

  #setActive(index) {
    for (const button of this.querySelectorAll('[data-gallery-nav]')) {
      if (Number(button.dataset.index) === index) {
        button.setAttribute('aria-current', 'true');
      } else {
        button.removeAttribute('aria-current');
      }
    }
  }
}

customElements.define('s-pdp-gallery', SPdpGallery);
